module.exports = "<script type=\"text/html\" id=\"jsoneditor\">\n    <div data-bind=\"visible: !hasAceEditor\">\n        <textarea\n            class=\"svd_json_editor_area\"\n            data-bind=\"textInput:koText, disable: readOnly, attr: { 'aria-label': 'JSON Editor' }\">\n        </textarea>\n        <!-- ko foreach: koErrors -->\n        <div>\n            <span>Error: </span><span data-bind=\"text: text\"></span>\n        </div>\n        <!-- /ko  -->\n    </div>\n    <div id=\"surveyjsJSONEditor\" class=\"svd_json_editor\"></div>\n</script>";


//////////////////
// WEBPACK FOOTER
// ./src/templates/jsoneditor.html
// module id = 107
// module chunks = 0